import { render, staticRenderFns } from "./modalPedido.vue?vue&type=template&id=111aeadc&"
import script from "./modalPedido.vue?vue&type=script&lang=js&"
export * from "./modalPedido.vue?vue&type=script&lang=js&"
import style0 from "./modalPedido.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports